export default __webpack_public_path__ + "static/media/21.01fe799e.png";